<template>
<!-- 转签 -->
  <div class="detail">
    <ax-panel>
      <van-cell title="保险缴纳区域" :value="data.header.gpcn_contrib_area_description"></van-cell>
      <van-cell title="当前公司实体" :value="data.header.company_description"></van-cell>
      <van-cell title="原合同预计结束日期" :value="data.header.contrct_exp_end_dt"></van-cell>
      <van-cell title="转签需求" :value="data.header.comments"></van-cell>
    </ax-panel>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>